import * as FormControl from '../../common/utils/form-controls';
import * as CONST from '../../common/utils/constants';

// global window
const filterObj = CONST.globalProject.ResourceFilters;
const filterDisplay = CONST.globalProject.ResourceFilterDisplay;

// initial state
// object name must match specification name
//specification, label, defaultValue, collapsible, expandDefault, groupType, subgroup, className
const filters = {
    searchTerm: new FormControl.FilterGroup(
        'SearchTerm', 'Search', '', false, true, 'textbox',
        new FormControl.Textbox('Search Resources', 'SearchTerm', true), 'filter-search', true
    ),
    Subject: new FormControl.FilterGroup('Subject', 'Subject', null, false, true, 'checkbox', undefined, 'filter-flex', 'False'),
    ContentType: new FormControl.FilterGroup('ContentType', 'Content Type', null, false, true, 'checkbox', undefined, 'filter-flex', 'False'),
};

FormControl.assignFilters(filterObj, filters);

filters.Subject.subgroup.unshift(new FormControl.SelectOption('999', 'All Topics', true, false, false));
filters.ContentType.subgroup.unshift(new FormControl.SelectOption('999', 'All Types', true, false, false));

export { filters as default };